<div class="container">
    <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">


        <div *ngFor="let item of items" class="product-item product-list-item">
            <div class="inner-content">
                <div class="product-thumb">
                    <a href="single-product.html">
                        <img src="{{item.ImagePath}}" width="322" height="360" alt="Image-HasTech">
                    </a>
                    <div class="product-flag">
                        <ul>
                            <li class="discount">{{item.Size}}</li>
                        </ul>
                    </div>
                 
                 
                </div>
                <div class="product-info">
                    <div class="category">
                        <ul>
                            <li><a >Moti</a></li>
                            <li class="sep">/</li>
                            <li><a >Kandora</a></li>
                        </ul>
                    </div>
                    <h4 class="title"><a >{{item.ProductName}}</a></h4>
                    <div class="prices">
                      
                        <span class="price">Rs {{item.Cost}}</span>
                    </div>
                    <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Voluptatem quo, rerum rem soluta quisquam,
                        repellat is deleniti omnis culpa ea quis provident dolore esse, offici modi dolorem nam cum eligendi
                        enim!</p>
                    <a class="btn-theme btn-sm" (click)="addToCart(item)">Add To Cart</a>
                </div>
            </div>
        </div>

       
    </div>
</div>